import _ from 'underscore';

export const getBudgetTitleDetails = (serverContext, i18n, budget) => {
  const currencyCode = serverContext.CurrentAccount.CurrencyCode;
  const amount = _.isNumber(budget && budget.Amount) ?
    i18n.formatCurrency(budget.Amount, currencyCode) :
    '-';
  return i18n.getString(_TL_('{{amount}} per day'), {
    amount,
  });
};
